import { useRouter } from 'next/router';
import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { LOCALES } from 'Utils/locale/constants';
import { getConfigWithNoThirdPartySupport } from './thirdParty.utils';
export const Udesk = () => {
  const { query: queryParams } = useRouter();
  const { isSeller, locale } = useAppContext();
  const { enabled, code, link, scriptUrl } = getConfigWithNoThirdPartySupport({
    name: 'udesk',
    locale,
    queryParams,
  });

  if (!isSeller && enabled && code) {
    return (
      <script
        dangerouslySetInnerHTML={{
          __html: `
(function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","${scriptUrl}","ud");
ud({
  "code": "${code}",
  "link": "${link}",
  "isInvite": true,
  "mode": "inner",
  "color": "#307AE8",
  "panel": {
    "css" : {
      "left": "4%",
    },
  },
  "pos_flag": "slb",
  "language": "${locale === LOCALES.ZH_CN ? 'zh-cn' : 'en-us'}",
  "mobile": {
    "mode": "inner",
    "color": "#307AE8",
    "pos_flag": "clb",
  }
});
    `,
        }}
      />
    );
  }

  return null;
};
